import React from 'react'
import { Well } from 'react-bootstrap'
import Modal from 'react-modal'

import { getSubModalStyles } from '../../common/utils'
import useSWR from '../../hooks/useSWR'

type Props = {
  isModalOpen: Boolean,
  closeModal: Function,
  rawDeliveryParams?: {
    carrierId: String,
    packageId: String,
  },
}

const defaultProps = {
  rawDeliveryParams: {},
}

const RawDeliveryModal = ({ isModalOpen, closeModal, rawDeliveryParams: { carrierId, packageId } }: Props) => {
  const { data } = useSWR(packageId && `/subject/admin/deliveries/raw?carrierId=${carrierId}&packageId=${packageId}`)

  const renderDeliveryItem = (item) => (
    <Well>
      <div>
        {Object.keys(item).map((key) => {
          const val = item[key]
          if (!val || val.length < 1) return null

          return (
            <div key={key}>
              <span style={{ fontSize: 16, fontWeight: 700 }}>{key}</span>
              <span style={{ fontSize: 16 }}>: {val}</span>
            </div>
          )
        })}
      </div>
    </Well>
  )

  if (!data && !packageId) return null

  return (
    <Modal isOpen={isModalOpen} onRequestClose={closeModal} style={getSubModalStyles()}>
      <button onClick={closeModal}>Stäng</button>
      <center>
        <hr />
        <h4>{`All rådata för kolli-ID ${packageId}`}</h4>
        {data && data.data ? (
          <div style={{ fontSize: 30, display: 'flex', flexDirection: 'column' }}>
            <div>{renderDeliveryItem(data.data)}</div>
          </div>
        ) : (
          <div>Hämtar...</div>
        )}
      </center>
    </Modal>
  )
}

RawDeliveryModal.defaultProps = defaultProps

export default RawDeliveryModal
